export enum CheckPriceState {
  Loading = 'LOADING',
  Available = 'OK',
  OnRequest = 'RQ',
  OnRequestRP = 'RP',
  Example = 'EX',
  NotAvailable = 'NA',
}

export function useCheckPrice(
  accom: MaybeRefOrGetter<TranslatedAccommodation>,
  trip: MaybeRefOrGetter<Partial<TripParams>>,
  vacancies: MaybeRefOrGetter<Trips | undefined>,
) {
  const query = computed(() => {
    const { pax, ...params } = toValue(trip)
    return { ...params, pax: pax ?? getAccomPaxMax(toValue(accom), params) }
  })

  const {
    data: result,
    error,
    isFetching,
    suspense,
  } = useCheckPriceFinalQuery(() => toValue(accom).code, query)

  const loading = computed(() => isFetching.value || !toValue(vacancies))
  const hasVacantDays = computed(() => !!toValue(vacancies)?.days)
  const optionPossible = computed(() => !!result.value?.optionCondition)
  const services = computed(() => result.value?.services ?? [])
  const alerts = computed(() => result.value?.alerts ?? [])
  const cancelConditions = computed(() => result.value?.cancelConditions ?? [])

  const price = computed<AccomPrice | undefined>(() => {
    if (!result.value) return undefined

    return {
      regularPrice: result.value.price.regularRentalPrice,
      price: result.value.price.customerTotalPrice,
      reduction: result.value.price.specialPriceReduction * -1,
      special: result.value.price.specialDescription,
    }
  })

  const state: ComputedRef<CheckPriceState> = computed(() => {
    if (loading.value) return CheckPriceState.Loading
    if (error.value || !hasVacantDays.value) return CheckPriceState.NotAvailable
    if (result.value) return result.value.stateCode as CheckPriceState

    return CheckPriceState.Example
  })

  return {
    state,
    query,
    price,
    optionPossible,
    services,
    alerts,
    cancelConditions,
    suspense,
  }
}
